import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidMemoryMatch } from '../../../../mechanics/rid-memory-match/rid-memory-match';

@Component({
  selector: 'app-memory-match-page',
  imports: [RidMemoryMatch],
  templateUrl: './memory-match-page.html',
})
export class MemoryMatchPage {
  protected readonly $router = inject(Router);
}
